import { Prefs } from "~/alias/prefs";
import { License } from "~/picreplacement/check";
export async function getFacts() {
    await Promise.all([Prefs.untilLoaded, License.ready()]);
    return {
        hasPremium: await License.isActiveLicense(),
        installDate: Prefs.get("installDate"),
        blockedCount: Prefs.get("blocked_total"),
    };
}
